import React from 'react';
import { Calendar } from 'lucide-react';
import { useTheme } from '@mui/material/styles';

const EmptyState = () => {
  const theme = useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: theme.palette.background.default, color: theme.palette.text.primary }}>
      <div className="text-center">
        <div className="mb-4">
          <Calendar size={64} className="mx-auto" style={{ color: theme.palette.text.disabled }} />
        </div>
        <p style={{ color: theme.palette.text.secondary }}>
          Please make necessary selections to load data
        </p>
      </div>
    </div>
  );
};

export default EmptyState;